import react from 'react'
import {
    Paper,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from "@mui/material";


const DinamicTable = (props) => {
    const keys = props.columnTitles.map(e => e['key']).flat()
    const finalData = props.data.map(e => {
        return Object.keys(e).
            filter((key) => keys.indexOf(key) != -1).
            reduce((cur, key) => { return Object.assign(cur, { [key]: e[key] }) }, {});
    })

    return (<TableContainer component={Paper} style={{ marginBottom: '30px' }} >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
                {props.extraHeaderRow && (
                    <TableRow className={'current-roadmap-cell'} >
                        {props.extraHeaderRowColSpan.map(e =>
                            <TableCell colSpan={e.col} className={e.className}>{e.title}</TableCell>
                        )}
                    </TableRow>
                )}
                <TableRow className={"current-roadmap-row"}>
                    {props.columnTitles.map(e =>
                        <TableCell style={{ borderLeft: '1px solid rgba(224, 224, 224, 1)' }} key={e.key} align={e.alignHeader}>{e.title}</TableCell>
                    )}
                </TableRow>
            </TableHead>
            <TableBody>
                {finalData.map((row) => {
                    return (
                        <TableRow
                            key={row.clientAge}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                            {props.columnTitles.map(e => {
                                const retrieveArguments = e.key.map((item) => row[item]);
                                return <TableCell
                                    key={e.key}
                                    align={e.alignCell}
                                    className={e.classNameCell}
                                >
                                    {e.function ? e.function(...retrieveArguments) : retrieveArguments.toString()}
                                </TableCell>
                            }
                            )}
                        </TableRow>
                    )
                })}
            </TableBody>
        </Table>
    </TableContainer>)
}

export default DinamicTable